import React, { useEffect, useState } from 'react';
import axios from 'axios';
import LoadingSpinner from '../../components/LoadingSpinner';

const FormClient = ({ clientId, onSubmit, onClose }) => {
  const [formData, setFormData] = useState({
    rut: '',
    business_name: '',
    contact: '',
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.rut || !formData.business_name) {
      alert('RUT y Razón social son obligatorios');
      return;
    }
    onSubmit(formData);
  };

  useEffect(() => {
    const fetchClient = async () => {
      if (!clientId) return;
      setIsLoading(true);
      try {
        const response = await axios.get(
          `${((import.meta.env.VITE_ENV == 'development') ? import.meta.env.VITE_BACKEND_LOCAL : import.meta.env.VITE_BACKEND)}/clients/${clientId}`,
          { withCredentials: true },
        );
        setFormData(response.data);
      } catch (error) {
        console.error('Error al cargar cliente:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchClient();
  }, [clientId]);

  return (
    <>
      {isLoading && (
        <LoadingSpinner message="Cargando cliente..." size="md" color="blue" fullScreen={false} />
      )}
      <form onSubmit={handleSubmit} className="space-y-4 max-w-sm mx-auto">
        <div className="mb-4">
          <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
            RUT*
          </label>
          <input
            type="text"
            name="rut"
            value={formData.rut}
            onChange={handleChange}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
            placeholder="12.345.678-9"
          />
        </div>
        <div className="mb-4">
          <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
            Razón social*
          </label>
          <input
            type="text"
            name="business_name"
            value={formData.business_name}
            onChange={handleChange}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
            placeholder="Nombre de la empresa"
          />
        </div>
        <div className="mb-4">
          <label className="block mb-1 text-sm font-medium text-gray-900 dark:text-white">
            Contacto
          </label>
          <input
            type="text"
            name="contact"
            value={formData.contact}
            onChange={handleChange}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
            placeholder="Persona de contacto / datos"
          />
        </div>

        <div className="flex justify-end gap-2 mt-4">
          <button
            type="button"
            onClick={onClose}
            className="bg-gray-200 text-gray-800 px-4 py-2 rounded-md"
          >
            Cancelar
          </button>
          <button
            type="submit"
            className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md"
          >
            Guardar
          </button>
        </div>
      </form>
    </>
  );
};

export default FormClient;

